import { Injectable, Provider } from '@angular/core';
import { Endereco } from 'src/app/api';

@Injectable()
export class EncomendaService {
  criar(pedido, encomenda): Promise<any> {
    throw new Error('not implemented');
  }
}

export function EncomendaServiceFactory(i: any) {
  return i.get('Encomenda');
}

export const EncomendaServiceProvider: Provider = {
  provide: EncomendaService,
  useFactory: EncomendaServiceFactory,
  deps: ['$injector'],
};
